import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { merge } from 'lodash';
import { EpdkSnackBarData } from './snack-bar';

@Component({
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class EpdkSnackBarComponent {
  static readonly DEFAULT_DATA: Partial<EpdkSnackBarData> = {
    message: 'Action confirmed.',
    iconName: '',
    actionText: '',
    showDismissButton: false,
  };

  constructor(
    public snackBarRef: MatSnackBarRef<EpdkSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: EpdkSnackBarData) { }

  ngOnInit(): void {
    this.data = merge({}, EpdkSnackBarComponent.DEFAULT_DATA, this.data);
  }
}